import { api } from "./api";
import type { Wallet, BaseWallet } from "../../types/WalletTypes";

export interface WalletsResponse {
  results: Wallet[];
}

export const walletsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getWallets: builder.query<WalletsResponse, void>({
      query: () => ({
        url: "/wallets/",
      }),
      providesTags: [{ type: "Wallets", id: "LIST" }],
    }),
    addWallet: builder.mutation<Wallet, BaseWallet>({
      query: (payload) => ({
        url: "/wallets/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Wallets", "Users"],
    }),
  }),
});

export const { useGetWalletsQuery, useAddWalletMutation } = walletsApi;
